<div class="igntr-theme flex-1 bg-[var(--background-color)]">
  <div
    class="max-w-[1180px] mx-auto px-[16px] pt-[16px] pb-[8px] md:px-[40px] md:pt-[24px] md:pb-[12px] flex flex-col gap-2"
  >
    <app-page-hero
      showSearchBar
      contentColumn
      [title]="pageTitle.title"
      [description]="pageTitle.description"
      [searchValue]="activeTab === 'documents' ? searchDocuments : searchTypes"
      (searchEmitter)="onSearch($event)"
    >
      <a
        class="hidden min-[576px]:flex grow basis-full sm:basis-[calc(50%-0.25rem)] xl:grow-0 xl:basis-auto justify-center items-center gap-1.5 text-[14px] bg-[var(--primary-color)] px-3.5 h-9 rounded-lg text-white font-medium shadow-[0_8px_18px_-10px_rgba(15,23,42,.5)]"
        [routerLink]="[addButtonLink()]"
      >
        <igntr-icon name="plus"></igntr-icon>
        {{ "add" | transloco }}
      </a>
    </app-page-hero>

    <div
      class="flex items-center justify-between gap-0.5 p-0.5 h-9 rounded-lg border !border-slate-200/70 bg-white"
    >
      <button
        type="button"
        class="flex-1 px-2.5 py-1 rounded-md text-[14px] flex justify-center items-center gap-1.5 transition-colors h-100"
        [ngClass]="
          activeTab === 'documents'
            ? '!bg-[var(--primary-color)] text-white'
            : '!text-slate-600 hover:!bg-slate-50'
        "
        (click)="changeTab('documents')"
      >
        {{ "documents" | transloco }}
      </button>
      <button
        type="button"
        class="flex-1 px-2.5 py-1 rounded-md text-[14px] flex justify-center items-center gap-1.5 transition-colors h-100"
        [ngClass]="
          activeTab === 'types'
            ? '!bg-[var(--primary-color)] text-white'
            : '!text-slate-600 hover:!bg-slate-50'
        "
        (click)="changeTab('types')"
      >
        {{ "document" | transloco }} {{ "types" | transloco }}
      </button>
    </div>
  </div>

  <div class="max-w-[1180px] mx-auto px-[16px] md:px-[40px] pb-[100px]">
    <div class="bg-white border border-slate-200/70 rounded-xl">
      @if (activeTab === "documents") {
        <div
          class="hidden md:grid grid-cols-[minmax(0,1fr)_36px] gap-3 px-4 py-2.5 bg-slate-50/60 border-b border-slate-200/70 text-[14px] font-semibold tracking-[0.08em] text-slate-500"
        >
          <button
            (click)="sortDocuments('Title')"
            class="text-left hover:text-slate-900 inline-flex items-center gap-1"
          >
            {{ "name" | transloco }}
            <span
              class="text-[14px]"
              [ngClass]="
                isSortedBy(documentsSort, 'Title')
                  ? 'text-slate-700'
                  : 'text-slate-300'
              "
            >
              {{ sortArrow(documentsSort, "Title") }}
            </span>
          </button>
          <div></div>
        </div>

        @if (repo.isLoading$ | async) {
          <app-spinner></app-spinner>
        }

        @for (doc of repo.page$ | async; track doc.id) {
          <div
            class="group grid grid-cols-[minmax(0,1fr)_36px] gap-3 px-4 py-3 border-b border-slate-100 last:border-b-0 hover:bg-slate-50/60 cursor-pointer transition-colors items-center"
            (click)="editDocument(doc)"
          >
            <div class="text-[14px] font-medium text-slate-900 truncate">
              {{ doc.title }}
            </div>
            <app-action-menu
              (click)="$event.stopPropagation()"
              class="self-center"
              [showEdit]="true"
              [showDelete]="true"
              (actionEdit)="editDocument(doc)"
              (actionDelete)="deleteDocument = doc"
            ></app-action-menu>
          </div>
        } @empty {
          <p class="text-muted px-4 py-3 text-[14px]">
            {{ "noItemsFound" | transloco }}
          </p>
        }

        <div class="px-4 py-3 border-t border-slate-100">
          <app-custom-pagination
            [page]="(repo.pageNumber$ | async) || 1"
            [total]="(repo.paginationData$ | async)?.lastPage || 0"
            (pageChange)="onDocumentsPageChange($event)"
          ></app-custom-pagination>
        </div>
      } @else {
        <div
          class="hidden md:grid grid-cols-[minmax(0,1fr)_160px_140px_36px] gap-3 px-4 py-2.5 bg-slate-50/60 border-b border-slate-200/70 text-[14px] font-semibold tracking-[0.08em] text-slate-500"
        >
          <button
            (click)="sortTypes('name')"
            class="text-left hover:text-slate-900 inline-flex items-center gap-1"
          >
            {{ "name" | transloco }}
            <span
              class="text-[14px]"
              [ngClass]="
                isSortedBy(typesSort, 'name')
                  ? 'text-slate-700'
                  : 'text-slate-300'
              "
            >
              {{ sortArrow(typesSort, "name") }}
            </span>
          </button>
          <div class="text-center">{{ "showOnSide" | transloco }}</div>
          <button
            (click)="sortTypes('updatedAt')"
            class="text-left hover:text-slate-900 inline-flex items-center gap-1"
          >
            {{ "updated" | transloco }}
            <span
              class="text-[14px]"
              [ngClass]="
                isSortedBy(typesSort, 'updatedAt')
                  ? 'text-slate-700'
                  : 'text-slate-300'
              "
            >
              {{ sortArrow(typesSort, "updatedAt") }}
            </span>
          </button>
          <div></div>
        </div>

        @if (typesRepo.isLoading$ | async) {
          <app-spinner></app-spinner>
        }

        @for (type of typesRepo.page$ | async; track type.id) {
          <div
            class="group grid grid-cols-[minmax(0,1fr)_36px] md:grid-cols-[minmax(0,1fr)_160px_140px_36px] gap-3 px-4 py-3 border-b border-slate-100 last:border-b-0 hover:bg-slate-50/60 cursor-pointer transition-colors items-center"
            (click)="editType(type)"
          >
            <div class="min-w-0">
              <div class="text-[14px] font-medium text-slate-900 truncate">
                {{ type.name }}
              </div>
              <div class="md:hidden text-[12px] text-slate-400 mt-0.5">
                {{ type.updatedAt | date: "dd-MM-yyyy HH:mm" }}
              </div>
            </div>

            <div
              class="hidden md:flex justify-center"
              (click)="$event.stopPropagation()"
            >
              <p-checkbox
                [binary]="true"
                [ngModel]="type.isShownOnSideMenu"
                (onChange)="setShownOnSideMenu(type, $event.checked)"
              ></p-checkbox>
            </div>

            <div
              class="hidden md:block text-[12px] text-slate-600 font-mono tabular-nums leading-tight"
            >
              {{ type.updatedAt | date: "dd-MM-yyyy HH:mm" }}
            </div>

            <app-action-menu
              (click)="$event.stopPropagation()"
              class="self-center"
              [showEdit]="true"
              [showDelete]="true"
              (actionEdit)="editType(type)"
              (actionDelete)="deleteType = type"
            ></app-action-menu>
          </div>
        } @empty {
          <p class="text-muted px-4 py-3 text-[14px]">
            {{ "noItemsFound" | transloco }}
          </p>
        }

        <div class="px-4 py-3 border-t border-slate-100">
          <app-custom-pagination
            [page]="(typesRepo.pageNumber$ | async) || 1"
            [total]="(typesRepo.paginationData$ | async)?.lastPage || 0"
            (pageChange)="onTypesPageChange($event)"
          ></app-custom-pagination>
        </div>
      }
    </div>
  </div>
</div>

@if (deleteDocument) {
  <app-confirm-delete
    id="deletedocumentmodal"
    [deleteCandidate]="deleteDocument.title"
    (confirm)="confirmDeleteDocument()"
    (cancel)="deleteDocument = null"
  ></app-confirm-delete>
}

@if (deleteType) {
  <app-confirm-delete
    id="deletedocumenttypemodal"
    [deleteCandidate]="deleteType.name"
    (confirm)="confirmDeleteType()"
    (cancel)="deleteType = null"
  ></app-confirm-delete>
}
